import moment from 'moment'

function time(unix) {
  if (typeof (unix) !== 'number') return unix
  if (unix == 0) return '-'
  return moment(unix).format('h:mm A')
}

export default time